import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthData } from 'app/core/data/auth-data';
import { AuthService } from 'app/core/security/auth.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
// TODO: @input name, ... ?

  public userData:Observable<AuthData>=null;

  constructor(public authService:AuthService) { 
    this.userData = authService.emitter;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/nav-bar/nav-bar.component.ts